'use client';

import Header from '@/components/common/Header';
import Footer from '@/app/home-page/components/Footer';
import Icon from '@/components/ui/AppIcon';

export default function ContactPage() {
  
  // Method to defeat automated DOM scraping bots
  const handleEmailReveal = (e: React.MouseEvent) => {
    e.preventDefault();
    const user = "ranjanr";
    const domain = "gmail.com";
    window.location.href = `mailto:${user}@${domain}?subject=AutoFixIQ Support`;
  };

  return (
    <div className="min-h-screen bg-background flex flex-col">
      <Header />
      <main className="flex-grow flex flex-col pt-12 pb-16">
        <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8 w-full">
          <h1 className="font-heading text-4xl font-bold text-text-primary mb-4">Contact Us</h1>
          <p className="font-body text-text-secondary mb-8">
            We are here to help ensuring you make smart decisions for your car repair.
          </p>
          
          <div className="bg-card rounded-xl shadow-elevation-md p-8 border border-border text-center max-w-md mx-auto mt-12">
            <div className="flex justify-center mb-6">
              <div className="flex h-16 w-16 items-center justify-center rounded-full bg-primary/10">
                <Icon name="EnvelopeIcon" size={32} className="text-primary" />
              </div>
            </div>
            <h2 className="font-heading text-2xl font-semibold text-text-primary mb-4">
              Get in Touch
            </h2>
            <p className="font-body text-sm text-text-secondary mb-8">
              Click the button below to reach our administration team directly via email. We typically respond within 24 hours.
            </p>
            
            <button 
              onClick={handleEmailReveal}
              className="inline-flex w-full items-center justify-center space-x-2 rounded-lg bg-primary px-6 py-4 font-body text-base font-medium text-primary-foreground transition-smooth hover:opacity-90 active:scale-[0.97]"
            >
              <Icon name="PaperAirplaneIcon" size={20} />
              <span>Email Support Team</span>
            </button>
            <p className="font-caption text-xs text-muted-foreground mt-4">
              Protected by anti-spam protocols
            </p>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
